var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4746 4.41929C21.7953 4.6814 21.8429 5.15389 21.5807 5.47462L11.2885 18.0686C10.8369 18.6212 10.015 18.6842 9.48452 18.2069L2.49837 11.9212C2.19044 11.6442 2.16541 11.1699 2.44246 10.862C2.71951 10.5541 3.19372 10.5291 3.50165 10.8061L10.2929 16.9164L20.4193 4.52542C20.6814 4.20469 21.1539 4.15717 21.4746 4.41929Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.5c81bd110420970c1dbdccd2d1881f42.svg";
export { ForwardRef as ReactComponent };